var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconUnderMaintenance = function SvgIconUnderMaintenance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9.5,
    fill: "#14111C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9E18",
    fillRule: "evenodd",
    d: "M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10S2 17.514 2 12 6.486 2 12 2m.043 5.412c-.949-.722-2.188-.97-3.077-.77l1.538 1.539-.769 1.538-1.538.77L6.658 8.95c-.2.889.048 2.129.77 3.077.983.757 2.193 1.012 3.076.77l3.51 3.33q.997.882 1.996-.117 1.06-1.06 0-2.12-3.243-3.184-3.198-3.402c.242-.883-.013-2.093-.77-3.076",
    clipRule: "evenodd"
  })));
};
export default SvgIconUnderMaintenance;